import { ThunkType } from "../../../../core/store/reducers";
import getOrderIndApi from "../api/getOrdesInd";
import { setDisplayed } from "../orderIndDataReducer";
import { OrderIndData } from "../types";

export const loadOrderInd = (orderid: number): ThunkType => async (
  dispatch,
  getStore
) => {
  dispatch(setDisplayed(undefined));

  const orderInd = await dispatch(getOrderIndicative(orderid));

  dispatch(setDisplayed(orderInd));
};

export const getOrderIndicative = (
  orderid: number
): ThunkType<Promise<OrderIndData | undefined>> => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { userId } = store.data.auth.current.user;
  return await dispatch(getOrderIndApi(userId, orderid));
};
